var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSoundIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#ffffff",
    width: "800px",
    height: "800px",
    viewBox: "-0.13 0 511.999 511.999",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_29_Sound_alt_",
    "data-name": "29 Sound (alt)",
    transform: "translate(-0.132 -0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M319.967,503.5v-67.34C394.335,409.733,447.9,339.457,447.9,256c0-83.426-53.565-153.732-127.934-180.156V8.5c110.288,28.485,191.9,128.309,191.9,247.5S430.254,475.043,319.967,503.5ZM256,511.868,128.066,383.935H32.115A31.965,31.965,0,0,1,.132,351.952V160.05a31.965,31.965,0,0,1,31.983-31.983h95.951L256,.133s31.983-4,31.983,31.983V479.885C287.983,515.866,256,511.868,256,511.868Zm-31.983-383.8L160.05,192.033H64.1V319.967H160.05l63.967,63.968V128.066ZM415.917,256c0,59.532-40.854,109.132-95.95,123.4V311.1a63.448,63.448,0,0,0,0-110.193V132.6C375.063,146.869,415.917,196.469,415.917,256Z",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundIcon);
export default __webpack_public_path__ + "static/media/sound-icon.7c3a67e654845c524784e9f116ab9b91.svg";
export { ForwardRef as ReactComponent };